import React, { useRef} from "react";
import { FaArrowRight, FaStar, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Slider.css";
import CurrencyService from "../services/currencyService"; 

function Slider({ guiders = [], stays = [], onHotelClick, type }) {
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  

  const scrollRight = () => {
    carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };
  const scrollLeft = () => {
    carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };



  // Use the correct array depending on type
  const items = type === "guider" ? guiders : stays;

  const handleClick = (item) => {
    if (type === "guider") {
      navigate("/guideprofilebook", { state: { guide: item } });
    } else {
      if (onHotelClick) {
        onHotelClick(item);
      } else {
        navigate("/travelerhotel", { state: { hotel: item } });
      }
    }
  };

  return (
    <div className="guider-carousel-wrapper">
      <div className="guider-carousel" ref={carouselRef}>
        {items.map((item) => (
          <div
            className="guider-card"
            key={item.id}
            onClick={() => handleClick(item)}
          >
            <div className="guider-image">
              <img
                src={item.image || "https://placehold.co/300x200?text=No+Image"}
                alt={item.name}
              />
            </div>

            <div className="guider-details">
              {/* Hotel or guider name */}
              <h3>{item.name || "SoloWay Stay"}</h3>
              {/* Show hotel room type cleanly */}
              {type === "hotel" && item.listing && (
                <h4 className="listing-name">
                  {item.listing.includes("@") ? item.listing.split("@")[0].trim() : item.listing}
                </h4>
              )}


              {/* Only for guider type */}
              {type === "guider" && item.guideName && (
                <p className="guide-name">Guide: {item.guideName}</p>
              )}

              {item.location && <p>{item.location}</p>}

              {/* Rating stars */}
              <div className="guider-stars">
                {Array.from({ length: 5 }).map((_, i) => {
                  const fullStar = i < Math.floor(item.rating || 0);
                  return (
                    <FaStar
                      key={i}
                      className={fullStar ? "star-full" : "star-empty"}
                    />
                  );
                })}
              </div>
                {item.price && (
                  <p className="guider-price">
                    {CurrencyService.getCurrencySymbol(CurrencyService.selectedCurrency)}{" "}
                    {CurrencyService
                      .convert(item.price, { fromCurrency: "LKR" })
                      .toFixed(2)}
                  </p>
                )}
              {item.reviews && <p className="guider-reviews">{item.reviews}</p>}
            </div>
          </div>
        ))}
      </div>

      <button className="guider-carousel-arrow left" onClick={scrollLeft}>
        <FaArrowLeft />
      </button>
      <button className="guider-carousel-arrow right" onClick={scrollRight}>
        <FaArrowRight />
      </button>
    </div>
  );
}

export default Slider;
